import React, { useRef, useEffect, useCallback } from "react";

interface LoadMoreProps {
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  fetchNextPage: () => void;
}

export const MyInfiniteLoadMore: React.FC<LoadMoreProps> = ({
  hasNextPage,
  isFetchingNextPage,
  fetchNextPage,
}) => {
  const loaderRef = useRef<HTMLDivElement>(null);

  const handleObserver = useCallback(
    (entries: IntersectionObserverEntry[]) => {
      const target = entries[0];
      if (target.isIntersecting && hasNextPage && !isFetchingNextPage) {
        fetchNextPage();
      }
    },
    [hasNextPage, isFetchingNextPage, fetchNextPage]
  );

  useEffect(() => {
    const option = {
      root: null,
      rootMargin: "0px",
      threshold: 1.0,
    };

    const observer = new IntersectionObserver(handleObserver, option);
    if (loaderRef.current) observer.observe(loaderRef.current);

    return () => {
      if (loaderRef.current) observer.unobserve(loaderRef.current);
    };
  }, [handleObserver]);

  return (
    <div className="flex justify-center mt-6">
      {isFetchingNextPage ? (
        <p className="text-gray-500">Loading...</p>
      ) : hasNextPage ? (
        <div ref={loaderRef} className="h-6 w-full"></div>
      ) : (
        <p className="text-gray-400">No more items</p>
      )}
    </div>
  );
};